import axios from "axios";
import {baseURL, otherBaseURL, dataScienceURL} from "../config";

export const INDICATORS = [
  {key: 'Mortgage_US', value: 'Mortgage Rate', disable: false},
  {key: 'GDP', value: 'GDP', disable: true},
  {key: 'Unemployment Rate', value: 'Unemployment Rate', disable: true},
  {key: 'Population', value: 'Population', disable: true},
  {key: 'Traffic Patterns', value: 'Traffic Patterns', disable: true}
]

export const LAGS = [
  {key: '3_months_lag', value: '3 Months Lag'},
  {key: '6_months_lag', value: '6 Months Lag'},
  {key: '12_months_lag', value: '12 Months Lag'}
]

export const LAGS_WHAT_IF_MULTI = [
  {key: '3_months', value: '3 Months Lag'},
  {key: '6_months', value: '6 Months Lag'},
  {key: '12_months', value: '12 Months Lag'}
]


export const OPTIONS_TABS = [
  {key: 'getHomeSales', value: 'Home Sales', id: 'homeSales', title: 'Home Sales', group: null},
  {
    key: 'getDaysOnMarket',
    value: 'Days on Market',
    id: 'daysOnMarket',
    title: 'Days on Market',
    group: null
  },
  {key: 'getMSP', value: 'MSP', id: 'msp', title: 'Median Sale Price ($)', group: null},
  {key: 'getPopulation', value: 'Population', id: 'population', title: 'Population', group: null},
  {key: 'getPPSF', value: 'Price', id: 'ppsf', title: 'PPSF ($)', group: null},
  {
    key: 'getBuildingPermits',
    value: 'Total Buildings',
    id: 'totalBuildings',
    title: 'Total Building Permits',
    group: 'Building Permits'
  },
  {
    key: 'getBuildingPermits',
    value: 'Total Units',
    id: 'totalUnits',
    title: 'Total Unit Permits',
    group: 'Building Permits'
  },
  {
    key: 'getBuildingPermits',
    value: 'Total Units($)',
    id: 'totalValue',
    title: 'Total Valuation of Building Permits($)',
    group: 'Valuation Permits'
  },
  {
    key: 'getBuildingPermits',
    value: 'One Unit',
    id: 'oneUnit',
    title: 'Building Permits for One Unit',
    group: 'Building Permits'
  },
  {
    key: 'getBuildingPermits',
    value: 'One Unit($)',
    id: 'oneUnitValue',
    title: 'Valuation of One Unit Building Permits($)',
    group: 'Valuation Permits'
  },
  {
    key: 'getBuildingPermits',
    value: 'Two Units',
    id: 'twoUnits',
    title: 'Building Permits for Two Units',
    group: 'Building Permits'
  },
  {
    key: 'getBuildingPermits',
    value: 'Two Units($)',
    id: 'twoUnitsValue',
    title: 'Valuation of Two Units Building Permits($)',
    group: 'Valuation Permits'
  },
  {
    key: 'getBuildingPermits',
    value: 'Three To Four Units',
    id: 'threeFourUnits',
    title: 'Building Permits for Three To Four Units',
    group: 'Building Permits'
  },
  {
    key: 'getBuildingPermits',
    value: 'Three To Four Units($)',
    id: 'threeFourUnitsValue',
    title: 'Valuation of Three To Four Units Building Permits($)',
    group: 'Valuation Permits'
  },
  {
    key: 'getBuildingPermits',
    value: 'More Than Five Units',
    id: 'moreThanFiveUnits',
    title: 'Building Permits for More Than Five Units',
    group: 'Building Permits'
  },
  {
    key: 'getBuildingPermits',
    value: 'More Than Five Units($)',
    id: 'moreThanFiveUnitsValue',
    title: 'Valuation of More Than Five Units Building Permits($)',
    group: 'Valuation Permits'
  }
]

const findMaxElementsKey = (input: any) => {
  let maxKey = null;
  let maxCount = 0;
  for (const key in input) {
    if (input.hasOwnProperty(key)) {
      const count = Object.keys(input[key]).length;
      if (count > maxCount) {
        maxCount = count;
        maxKey = key;
      }
    }
  }

  return maxKey;
}

export const transformData = (input: any) => {
  if (input['Mortgage_US']) delete input['Mortgage_US']
  const output: any = [];
  const keys = Object.keys(input);
  const maxKey = findMaxElementsKey(input);
  // @ts-ignore
  const dates = Object.keys(input[maxKey]);

  dates.forEach(date => {
    const obj = {date};

    keys.forEach(key => {
      const inputValue = input[key][date] || 0
      // @ts-ignore
      obj[key] = parseFloat(inputValue).toFixed(2);
    });

    output.push(obj);
  });
  output.sort((a: any, b: any) => {
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    // @ts-ignore
    return dateA - dateB;
  });

  return output;
}

export const whatIfAPICall = async (state: any, indicator: any, percentage: any, name: any, lag: any, type: string) => {
  const response = await axios.get(`${otherBaseURL}realestateTrigger/${state}/${indicator}/${percentage}/${name}/${lag}/${type}`)
  const data = response.data
  const overall = data?.metrics_change_dict
  const isChartAvailable = !overall?.no_growth

  if (isChartAvailable) {
    const PPSFAdjustedData = transformData(data?.ppsf_chart_data)
    const HSAdjustedData = transformData(data?.hs_chart_data)
    const DOMAdjustedData = transformData(data?.dom_chart_data)
    const PPSFTimelineData = transformData(data?.components_df_ppsf)
    const HSTimelineData = transformData(data?.components_df_hs)
    const DOMTimelineData = transformData(data?.components_df_dom)
    const PPSFGrowthData = transformData(data?.ppsf_vs_mr_growth)
    const HSGrowthData = transformData(data?.hs_vs_mr_growth)
    const DOMGrowthData = transformData(data?.dom_vs_mr_growth)
    return {
      overall,
      isChartAvailable,
      PPSFAdjustedData,
      HSAdjustedData,
      DOMAdjustedData,
      PPSFTimelineData,
      HSTimelineData,
      DOMTimelineData,
      PPSFGrowthData,
      HSGrowthData,
      DOMGrowthData
    }
  } else {
    return {
      overall,
      isChartAvailable
    }
  }
}

export const getMortgageRate = async () => {
  try {
    const response = await axios.get(`${baseURL}getCurrentMortegageRate`);
    return response.data
  } catch (e) {
    console.error(e)
    return 0
  }
}

export const whatIfMultiAPICall = async (state: any, mRate: any, uRate: any, pRate: any, city: any, lag: any, isMsa: boolean = false) => {
  const rateM = isNaN(Number(mRate)) ? 0 : Number(mRate)
  const rateU = isNaN(Number(uRate)) ? 0 : Number(uRate)
  const rateP = isNaN(Number(pRate)) ? 0 : Number(pRate)
  try {
    let url = `${otherBaseURL}whatIfMultiCriteria/${state}/${rateM}/${rateU}/${rateP}/${city}/${lag}`
    if (isMsa) url = `${url}/metro`
    else url = `${url}/city`
    const response = await axios.get(url)
    const data = response.data
    const overall = data?.metric_change_dict
    const isChartAvailable = !overall?.no_growth
    if (isChartAvailable) {
      const PPSFAdjustedData = transformData(data?.ppsf_chart_data)
      const HSAdjustedData = transformData(data?.hs_chart_data)
      const DOMAdjustedData = transformData(data?.dom_chart_data)
      const PPSFTimelineData = transformData(data?.components_df_ppsf)
      const HSTimelineData = transformData(data?.components_df_hs)
      const DOMTimelineData = transformData(data?.components_df_dom)
      const PPSFPopulationCompareData = transformData(data?.ppsf_vs_pop_growth)
      const PPSFMortgageCompareData = transformData(data?.ppsf_vs_mort_growth)
      const PPSFUnemploymentCompareData = transformData(data?.ppsf_vs_unemp_growth)
      const HSPopulationCompareData = transformData(data?.hs_vs_pop_growth)
      const HSMortgageCompareData = transformData(data?.hs_vs_mort_growth)
      const HSUnemploymentCompareData = transformData(data?.hs_vs_unemp_growth)
      const DOMPopulationCompareData = transformData(data?.dom_vs_pop_growth)
      const DOMMortgageCompareData = transformData(data?.dom_vs_mort_growth)
      const DOMUnemploymentCompareData = transformData(data?.dom_vs_unemp_growth)
      return {
        overall,
        isChartAvailable,
        PPSFAdjustedData,
        HSAdjustedData,
        DOMAdjustedData,
        PPSFTimelineData,
        HSTimelineData,
        DOMTimelineData,
        PPSFPopulationCompareData,
        PPSFMortgageCompareData,
        PPSFUnemploymentCompareData,
        HSPopulationCompareData,
        HSMortgageCompareData,
        HSUnemploymentCompareData,
        DOMPopulationCompareData,
        DOMMortgageCompareData,
        DOMUnemploymentCompareData,
        isError: false
      }
    } else {
      return {
        overall,
        isChartAvailable,
        isError: true
      }
    }
  } catch (e) {
    console.error(e)
    return {
      isChartAvailable: false,
      isError: true
    }
  }

}

const checkNumber = (num: any, precision: boolean = false) => {
  if (num) {
    if (precision)
      return num.toFixed(3)
    return num
  }
  if (num === 0) return num
  return 'No Data'
}


export const getMultiAnalysisData = async (state: string, city: string, isMsa: boolean = false) => {
  let data = {
    mortgageRate: 'No Data',
    unemploymentRate: 'No Data',
    population: 'No Data',
    population_growth: 'No Data'
  }
  try {
    let url = `${dataScienceURL}getMultiAnalysisData?state=${state}&city=${city}`
    if (isMsa) {
      url = `${dataScienceURL}getMultiAnalysisDataMetro?state=${state}&metroarea=${city}`
    }
    const response = await axios.get(url)
    if (response?.data && response?.data?.cube && response?.data?.cube.length) {
      const info = response?.data?.cube[0]
      data.mortgageRate = checkNumber(info.mortegage_rate)
      data.unemploymentRate = checkNumber(info.unemployement_rate)
      data.population = checkNumber(info.population)
      data.population_growth = checkNumber(info.current_population_growth, true)
    }
  } catch (e) {
    console.error(e)
  }

  return data
}

